import { attachmentService } from '@/services'

export default {
  state: {
    attachments: [],
    attachmentsCount: 0,
    fileManager: {}
  },

  mutations: {
    setAttachments (state, { attachments, count }) {
      state.attachments = attachments
      state.attachmentsCount = count
    },

    addAttachment (state, value) {
      const attachments = state.attachments
      attachments.unshift(value)

      state.attachments = attachments
      state.attachmentsCount++
    },

    setFileManager (state, value) {
      state.fileManager = value
    },

    deleteAttachment (state, id) {
      state.attachments = state.attachments.filter(item => item.id !== id)
      state.attachmentsCount--
    },

    deleteMultipleAttachment (state, ids) {
      state.attachments = state.attachments.filter(item => !ids.includes(item.id))
      state.attachmentsCount = state.attachmentsCount - ids.length
    },

    updateName (state, { id, name }) {
      state.attachments = state.attachments.map(item => {
        if (item.id === id) {
          return {
            ...item,
            name
          }
        }

        return item
      })
    }
  },

  actions: {
    async getAttachments ({ commit }, { bookIds, limit, fileManagerId, search }) {
      const { data } = await attachmentService.getFilesForManager({ bookIds, limit, fileManagerId, search })
      commit('setAttachments', {
        attachments: data.files,
        count: data.count
      })
    },

    async getFileManager ({ commit }) {
      const { data } = await attachmentService.getFileManager()
      commit('setFileManager', data)
      return data
    },

    async updateAttachmentName ({ commit }, { name, id }) {
      await attachmentService.updateName({ name, id })
      commit('updateName', { id, name })
    },

    async deleteFromManager ({ commit }, { id }) {
      await attachmentService.deleteFromManager({ id })
      commit('deleteAttachment', id)
    }
  }
}
